import React from 'react';
import { AlertTriangle, Info } from 'lucide-react';

export function OveragePolicyCard(props: { currentUsage: number; limit: number; tier: string; onUpgrade: () => void }) {
  const { currentUsage, limit, onUpgrade } = props;
  const pct = limit > 0 ? currentUsage / limit : 0;
  const isWarning = limit > 0 && pct >= 0.8 && pct < 1;
  const isBlocked = limit > 0 && pct >= 1;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-2">
        {isWarning || isBlocked ? (
          <AlertTriangle className={`w-4 h-4 ${isBlocked ? 'text-red-600' : 'text-orange-600'}`} />
        ) : (
          <Info className="w-4 h-4 text-gray-700" />
        )}
        <h4 className="font-semibold text-black">Overage Policy</h4>
      </div>

      <p className="text-sm text-gray-700">
        <span className="font-medium">Hard limit:</span> When you reach your limit, you’ll be prompted to upgrade to continue generating
        comment summaries. There’s no overage billing.
      </p>

      {(isWarning || isBlocked) && (
        <div className={`mt-3 p-3 rounded-md ${isBlocked ? 'bg-red-50 border border-red-200' : 'bg-orange-50 border border-orange-200'}`}>
          <div className={`text-sm font-medium ${isBlocked ? 'text-red-800' : 'text-orange-800'}`}>
            {isBlocked ? 'Limit reached' : 'Approaching your limit'}
          </div>
          <div className={`text-xs mt-1 ${isBlocked ? 'text-red-700' : 'text-orange-700'}`}>
            {limit > 0 ? `${currentUsage} / ${limit} comment summaries used this billing period.` : 'Your plan has unlimited summaries.'}
          </div>
          <button
            onClick={onUpgrade}
            className="mt-3 w-full px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white font-semibold"
          >
            View plans
          </button>
        </div>
      )}
    </div>
  );
}


